import { render } from "./ProductsContent.vue?vue&type=template&id=9c0d263c&scoped=true&ts=true"
import script from "./ProductsContent.vue?vue&type=script&lang=ts"
export * from "./ProductsContent.vue?vue&type=script&lang=ts"

import "./ProductsContent.vue?vue&type=style&index=0&id=9c0d263c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0d263c"]])

export default __exports__